import { useReactNativeHandler } from './event-handler'
import { PushNotificationAction, PushNotificationToken, ReactNativePayload } from './types'

interface Props {
  setPushToken: (value: string) => void
}

/**
 * custom hook that initializes React Native Message handling with registering to
 * React Native Event Handler for different actions
 */
const useReactNativeMessages = ({ setPushToken }: Props): void => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const messageOfTheDayCallback = (payload: ReactNativePayload): void => {}

  /**
   * Sets the token for push notifications which can then be used e.g. for subscribing to the push notification service
   */
  const pushNotificationTokenCallback = (payload: ReactNativePayload): void => {
    setPushToken((payload as PushNotificationToken).token)
  }

  useReactNativeHandler(PushNotificationAction.MessageOfTheDay, messageOfTheDayCallback)
  useReactNativeHandler(PushNotificationAction.PushNotificationAction, pushNotificationTokenCallback)
}

export default useReactNativeMessages
